import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NxFormLoginComponent } from './nx-form-login.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';



@NgModule({
  declarations: [
    NxFormLoginComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule
  ],
  exports: [
    NxFormLoginComponent
  ]

})
export class NxFormLoginModule { }
